<style lang="scss" scoped>
</style>

<template>
  <div>
    <div class="sidebar-title is-size-5 pb-4">Regenerate Key</div>
    <div>
      <p>
        Are you sure you wish to regenerate your key?  This will invalidate your existing key.  Your new key will show
        on this page temporarily until you navigate away.
      </p>
      <p v-if="errors.key" class="help is-danger pt-2">{{errors.key}}</p>
      <div class="pt-5">
        <button class="button is-primary mr-5" @click.prevent="submit">Yes</button>
        <button class="button is-default" @click="$emit('complete')">No</button>
      </div>
    </div>
  </div>
</template>

<script>
import api from '@/api';


export default {
  name: 'devices',
  data () {
    return {
      data: {},
      errors: {}
    };
  },
  methods: {
    async submit() {
      try {
        await api.user.rekey();
        this.errors = {};
        this.data = {};
        this.$emit('complete');
      } catch (error) {
        this.handle();
      }
    },
    handle() {
      this.errors = {};
      this.errors.key = 'There was an error regenerating your key.';
    }
  }
};
</script>
